import React from 'react';
import { Button } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { useNotification } from '../../../../Helper/NotificationProvider';
import * as XLSX from 'xlsx';

const FileExport = ({ guestList, currentLocation, event }) => {
  const { t } = useTranslation();
  const { openNotification } = useNotification();

  const handleExport = () => {
    if (
      !currentLocation.scanPaths ||
      currentLocation.scanPaths.length === 0 ||
      !currentLocation.layout ||
      currentLocation.layout.length === 0 ||
      !guestList || guestList.length === 0
    ) {
      openNotification(
        'bottomRight',
        t('Fehler'),
        t('Keine Daten zum Exportieren.'),
        false
      );
      return;
    }

    // Step 1: Extract Shape IDs from scanPaths in Order
    const shapeIdsOrdered = [];
    currentLocation.scanPaths.forEach((scanPath) => {
      if (scanPath.path && Array.isArray(scanPath.path)) {
        scanPath.path.forEach((shapeId) => {
          if (!shapeIdsOrdered.includes(shapeId)) {
            shapeIdsOrdered.push(shapeId);
          }
        });
      }
    });

    const exportData = [];
    shapeIdsOrdered.forEach((shapeId, index) => {
      const chair = currentLocation.layout.find(
        (chairItem) => chairItem.shape && chairItem.shape.id === shapeId
      );
      const guest = guestList.find(
        (guestItem) => guestItem.chair === shapeId);

      if (chair) {
        exportData.push({
          'UID': chair.chairId,
          'Sitzplatznummer': chair.shape.number,
          'Reihe': chair.shape.row,
          'Block': chair.shape.block,
          'Template': guest.matching.template || event.templateName,
          'Label-ID': guest.matching.label || '',
          'Vorname': guest.name || '',
          'Nachname': guest.surname || '',
          'Anrede/Titel': guest.title || '',
          'Firma': guest.companyInfo || '',
          'Freifeld': guest.message || '',
        });
      } else {
        console.warn(`Stuhl mit der Form-ID "${shapeId}" wurde im Layout nicht gefunden.`);
        exportData.push({
          'UID': shapeId,
          'Sitzplatznummer': '',
          'Reihe': '',
          'Block':'',
          'Template': '',
          'Label-ID': '',
          'Vorname': '',
          'Nachname': '',
          'Anrede/Titel':'',
          'Firma': '',
          'Freifeld': '',
        });
      }
    });

    if (exportData.length === 0) {
      openNotification(
        'bottomRight',
        t('Fehler'),
        t('Keine gültigen Stuhldaten zum Exportieren gefunden.'),
        false
      );
      return;
    }

    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Gästeliste');
    const wbout = XLSX.write(workbook, { bookType: 'xlsx', type: 'binary' });

    function s2ab(s) {
      const buf = new ArrayBuffer(s.length);
      const view = new Uint8Array(buf);
      for (let i = 0; i < s.length; i++) {
        view[i] = s.charCodeAt(i) & 0xff;
      }
      return buf;
    }

    const blob = new Blob([s2ab(wbout)], { type: 'application/octet-stream' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `Gästeliste_${event?.name.replace(" ", "_") || 'Export'}.xlsx`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);

    openNotification(
      'bottomRight',
      t('Export erfolgreich'),
      t('Die Gästeliste wurde erfolgreich exportiert.'),
      true
    );
  };

  return (
    <Button
      type="default"
      icon={<DownloadOutlined />}
      onClick={handleExport}
      style={{ marginLeft: '10px' }}
    >
      {t('Gästeliste exportieren')}
    </Button>
  );
};

export default FileExport;
